// extracted by css-extract-rspack-plugin
export default {"text":"SetupQRStep_text__sxOWe","subtext":"SetupQRStep_subtext__fT2i5","qrCode":"SetupQRStep_qrCode__yhlMY","copyWrapper":"SetupQRStep_copyWrapper__+8a5q"};